import { UserRequestModel } from "libs/models/user-model";
import { ValidationModel } from "libs/models/validate-model";
import { UserStore } from "store/slices/users";
import translate from "utils/translations";

export const validateAddUserState = (
  state: UserStore
): ValidationModel<UserRequestModel> => {
  let validationModel = {} as ValidationModel<UserRequestModel>;
  if (!state.isValidating) {
    return validationModel;
  }
  if (
    state.newUserData.firstName === undefined ||
    state.newUserData.firstName === ""
  ) {
    validationModel.firstName = translate(
      "Required_Text",
      "This field is required"
    );
  } else if (/\d/.test(state.newUserData.firstName)) {
    validationModel.firstName = translate(
      "Invalid_Data_Text",
      "Name cannot contain numbers"
    );
  }
  if (state.newUserData.firstName && state.newUserData.firstName.length > 200) {
    validationModel.firstName = translate("Long_Text", "Text is too long");
  }
  if (
    state.newUserData.firstName &&
    state.newUserData.firstName !== "" &&
    state.newUserData.firstName.length < 2
  ) {
    validationModel.firstName = translate("Short_Text", "Text is too short");
  }
  if (
    state.newUserData.lastName === undefined ||
    state.newUserData.lastName === ""
  ) {
    validationModel.lastName = translate(
      "Required_Text",
      "This field is required"
    );
  } else if (/\d/.test(state.newUserData.lastName)) {
    validationModel.lastName = translate(
      "Invalid_Data_Text",
      "Name cannot contain numbers"
    );
  }
  if (state.newUserData.lastName && state.newUserData.lastName.length > 200) {
    validationModel.lastName = translate("Long_Text", "Text is too long");
  }
  if (
    state.newUserData.lastName &&
    state.newUserData.lastName !== "" &&
    state.newUserData.lastName.length < 2
  ) {
    validationModel.lastName = translate("Short_Text", "Text is too short");
  }
  if (state.newUserData.email === null || state.newUserData.email === "") {
    validationModel.email = translate(
      "Required_Text",
      "This field is required"
    );
  }
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (
    state.newUserData.email !== "" &&
    !emailRegex.test(state.newUserData.email)
  ) {
    validationModel.email = translate("Email_Error", "Invalid email address");
  }
  if (
    state.newUserData.roleId === null ||
    state.newUserData.roleId === undefined
  ) {
    validationModel.roleId = translate(
      "Required_Text",
      "This field is required"
    );
  }

  return validationModel;
};
